import React from 'react'

function ProcessingStatus({ isLoading, error, sheetNames }) {
    return (
        <>
            {isLoading && (
                <div className="text-center my-6">
                    <div className="inline-block animate-spin-slow-clockwise rounded-full h-8 w-8 border-t-2 border-b-2 border-blue-500 mb-2"></div>
                    <p className="font-medium text-blue-600">Processing file...</p>
                </div>
            )}

            {error && (
                <div className="bg-red-50 border-l-4 border-red-500 p-4 my-6">
                    <div className="flex">
                        <div className="flex-shrink-0">
                            <svg className="h-5 w-5 text-red-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                                <path
                                    fillRule="evenodd"
                                    d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
                                    clipRule="evenodd"
                                />
                            </svg>
                        </div>
                        <div className="ml-3">
                            <p className="text-sm text-red-700">{error}</p>
                        </div>
                    </div>
                </div>
            )}

            {sheetNames.length > 0 && (
                <div className="mb-6 p-4 bg-gray-50 rounded-lg">
                    <h4 className="text-sm font-medium text-gray-700 mb-2">Processed Sheets:</h4>
                    <div className="flex flex-wrap gap-2">
                        {sheetNames.map((name, index) => (
                            <span key={index} className="px-2 py-1 bg-gray-200 rounded-md text-xs text-gray-700">
                                {name}
                            </span>
                        ))}
                    </div>
                </div>
            )}
        </>
    )
}

export default ProcessingStatus
